// src/components/usuario/EncuestasUsuario.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { FiCheckCircle, FiClock } from "react-icons/fi";
import { ENDPOINTS } from "../../Utils/Endpoints";
import { getSessionUserId } from "../../../../utils/SessionUser";
import "../../Styles/index.css";
import EncuestaModal from "./EncuestaModal";

const EncuestasUsuario = ({ onVolver }) => {
    const [encuestas, setEncuestas] = useState([]);
    const [loading, setLoading] = useState(false);

    // Modal state
    const [showModal, setShowModal] = useState(false);
    const [selectedEncuesta, setSelectedEncuesta] = useState(null);

    const currentUser = { idUsuario: getSessionUserId() };

    // Carga inicial
    useEffect(() => {
        cargarDatos();
    }, []);

    const cargarDatos = async () => {
        setLoading(true);
        try {
            const res = await axios.get(ENDPOINTS.encuestasDashboardByUsuarioId(currentUser.idUsuario));

            const encuestasFormateadas = (res.data || []).map(e => ({
                ...e,
                idEncuesta: e.idEncuesta || e.IdEncuesta,
                nombre: e.titulo || e.Titulo || e.nombre || e.Nombre || "Encuesta",
                descripcion: e.descripcion || e.Descripcion || "",
                nombreArea: e.nombreArea || e.NombreArea || "General",
                respondidaUsuario: e.respondidaUsuario !== undefined ? e.respondidaUsuario : e.RespondidaUsuario,
                esActiva: e.esActiva !== undefined ? e.esActiva : (e.EsActiva !== undefined ? e.EsActiva : true)
            }));

            setEncuestas(encuestasFormateadas);

        } catch (error) {
            console.error("Error cargando encuestas dashboard:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleOpenModal = (encuesta) => {
        setSelectedEncuesta(encuesta);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedEncuesta(null);
    };

    const renderSurveyCard = (encuesta, idx) => {
        const isRespondida = encuesta.respondidaUsuario;

        // Estilos visuales basados en el estado
        const statusConfig = isRespondida ? {
            bg: '#15803d', // Verde
            label: 'COMPLETADA',
            icon: <FiCheckCircle />,
            cardBg: '#f0fdf4',
            buttonLabel: 'Ver detalles'
        } : {
            bg: '#3b82f6', // Azul
            label: 'PENDIENTE',
            icon: <FiClock />,
            cardBg: '#ffffff',
            buttonLabel: 'Responder ahora'
        };

        return (
            <article
                key={encuesta.idEncuesta || idx}
                onClick={() => handleOpenModal(encuesta)}
                style={{
                    backgroundColor: statusConfig.cardBg,
                    border: `1px solid ${statusConfig.bg}`, // Borde sólido y delgado del color del estatus
                    borderRadius: '12px',
                    overflow: 'hidden',
                    transition: 'all 0.2s ease',
                    cursor: 'pointer',
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = `0 8px 16px ${statusConfig.bg}25`;
                    e.currentTarget.style.transform = 'translateY(-6px)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
                    e.currentTarget.style.transform = 'translateY(0)';
                }}
            >
                {/* Badge de estado (Triángulo esquina superior) */}
                <div style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    width: '50px',
                    height: '50px',
                    zIndex: 2,
                    overflow: 'hidden'
                }}>
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        width: 0,
                        height: 0,
                        borderStyle: 'solid',
                        borderWidth: '0 50px 50px 0',
                        borderColor: `transparent ${statusConfig.bg} transparent transparent`,
                    }} />
                    <div style={{
                        position: 'absolute',
                        top: '6px',
                        right: '6px',
                        color: 'white',
                        fontSize: '1.2rem',
                        display: 'flex',
                        zIndex: 3
                    }}>
                        {statusConfig.icon}
                    </div>
                </div>

                <div style={{ padding: '1.5rem', flex: 1 }}>
                    <div style={{ marginBottom: '1rem' }}>
                        <span style={{
                            padding: '0.25rem 0.75rem',
                            borderRadius: '999px',
                            fontSize: '0.7rem',
                            fontWeight: 800,
                            backgroundColor: `${statusConfig.bg}15`,
                            color: statusConfig.bg,
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                            border: `1px solid ${statusConfig.bg}33`
                        }}>
                            {encuesta.nombreArea}
                        </span>
                    </div>

                    <h3 style={{
                        fontSize: '1.15rem',
                        fontWeight: 800,
                        color: '#1e293b',
                        marginBottom: '0.75rem',
                        lineHeight: 1.3
                    }}>
                        {encuesta.nombre}
                    </h3>

                    <p style={{
                        fontSize: '0.875rem',
                        color: '#64748b',
                        lineHeight: 1.6,
                        marginBottom: 0,
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden'
                    }}>
                        {encuesta.descripcion || "Sin descripción disponible."}
                    </p>
                </div>

                <div
                    style={{
                        marginTop: 'auto',
                        padding: '0.75rem 1rem 1.25rem',
                        backgroundColor: 'transparent',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'all 0.2s ease'
                    }}
                >
                    <span style={{
                        fontSize: '0.9rem',
                        color: statusConfig.bg,
                        fontWeight: 700,
                    }}>
                        {statusConfig.buttonLabel}
                    </span>
                </div>
            </article>
        );
    };

    return (
        <div className="intra-avisos-page">
            <header className="intra-news-header">
                <div>
                    {onVolver && (
                        <button
                            type="button"
                            className="intra-button-back"
                            onClick={onVolver}
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                                padding: '0.5rem 1rem',
                                marginBottom: '1rem',
                                backgroundColor: 'transparent',
                                border: '1px solid #cbd5e1',
                                borderRadius: '8px',
                                color: '#475569',
                                fontSize: '0.875rem',
                                fontWeight: 500,
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#f1f5f9';
                                e.currentTarget.style.transform = 'translateX(-4px)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent';
                                e.currentTarget.style.transform = 'translateX(0)';
                            }}
                        >
                            <span style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>←</span>
                            <span>Volver al dashboard</span>
                        </button>
                    )}
                    <h1 className="intra-news-title">Encuestas Disponibles</h1>
                </div>
            </header>

            {loading ? (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '5rem' }}>
                    <div className="spinner" style={{ marginBottom: '1rem' }}></div>
                    <p style={{ color: '#94a3b8', fontWeight: 500 }}>Sincronizando encuestas...</p>
                </div>
            ) : encuestas.length === 0 ? (
                <div style={{
                    textAlign: 'center',
                    padding: '5rem 2rem',
                    backgroundColor: 'white',
                    borderRadius: '16px',
                    border: '1px dashed #cbd5e1',
                }}>
                    <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📋</div>
                    <p style={{ fontSize: '1.25rem', color: '#1e293b', fontWeight: 600, marginBottom: '0.5rem' }}>
                        ¡Todo al día!
                    </p>
                    <p style={{ fontSize: '1rem', color: '#64748b' }}>
                        No tienes encuestas pendientes por el momento.
                    </p>
                </div>
            ) : (
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
                    gap: '2rem',
                }}>
                    {encuestas.map((encuesta, idx) => renderSurveyCard(encuesta, idx))}
                </div>
            )}

            {showModal && selectedEncuesta && (
                <EncuestaModal
                    encuesta={selectedEncuesta}
                    onClose={handleCloseModal}
                    onEncuestaEnviada={cargarDatos}
                />
            )}
        </div>
    );
};

export default EncuestasUsuario;
